import { ChangeEvent, FC, useState } from "react";
import ModalPortal from "components-new/ModalPortal";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import { Search } from "components-new";
import { Link } from "react-router-dom";
import { IOrganizationShort } from "toolkit/organizations/types";
import styles from "./AttentionModal.module.sass";

interface AttentionModalProps {
	handleSearchValue: (e: ChangeEvent<HTMLInputElement>) => void;
	searchValue: string;
	organizations: { actual: IOrganizationShort[]; temp: IOrganizationShort[] };
	close: () => void;
	submit: () => void;
}

const AttentionModal: FC<AttentionModalProps> = ({ handleSearchValue, searchValue, organizations, close, submit }) => {
	const [listVisible, setListVisible] = useState<boolean>(false);

	return (
		<ModalPortal title="Внимание" handleClose={close} size="sl" outSide={false}>
			<p className={styles.text}>
				Функция будет отключена в организациях, завершивших процесс категорирования. В данных{" "}
				<span className={listVisible ? "" : "link"} onClick={() => setListVisible(true)}>
					организациях
				</span>{" "}
				функция станет доступна после завершения процесса.
			</p>

			{listVisible && (
				<div>
					<Search className={styles.search} searchValue={searchValue} handleSearch={handleSearchValue} />

					<div className={styles.organizationCount}>Организации ({organizations.actual.length})</div>

					<div className={styles.organizations}>
						{searchValue
							? organizations.temp.map((organization) => (
									<Link
										key={organization.id}
										className={styles.organizationsItem}
										to={`/organization/${organization.id}`}>
										{organization.fullName}
									</Link>
							  ))
							: organizations.actual.map((organization) => (
									<Link
										key={organization.id}
										className={styles.organizationsItem}
										to={`/organization/${organization.id}`}>
										{organization.fullName}
									</Link>
							  ))}
					</div>
				</div>
			)}

			<div className="df">
				<Button full onClick={submit} variant={BUTTON_VARIANTS.OUTLINED}>
					Продолжить
				</Button>
				<Button className={styles.btn} full onClick={close}>
					Отмена
				</Button>
			</div>
		</ModalPortal>
	);
};

export default AttentionModal;
